<template>
	<!-- Deprecated !! Used by legacy route from old ecom-->
</template>

<script>
import EcomReskinMixin from '@/mixins/EcomReskinMixin'

export default {
	name: 'ProductPage',
	mixins: [EcomReskinMixin],
	// TODO : Need to be rework with middleware from route or something
	created () {
		return this.redirectToProductV2UrlFromSlug(this.$route.params.slug)
	},
}
</script>
